import React from 'react';
import {
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemButton
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Reports = () => {
  const navigate = useNavigate();
  
  const reportTypes = [
    { id: 1, name: 'Project Timeline', type: 'production' },
    { id: 2, name: 'Facility Report', type: 'facility' },
    { id: 3, name: 'Quality Report', type: 'quality' },
    { id: 4, name: 'Resource Utilization', type: 'resources' },
    { id: 5, name: 'Progress Overview', type: 'progress' },
    { id: 6, name: 'Cost Analysis', type: 'cost' }
  ];

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Reports
      </Typography>
      
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Select Report Type
        </Typography>
        <List>
          {reportTypes.map((report) => (
            <ListItem key={report.id} disablePadding>
              <ListItemButton onClick={() => {
                if (report.type === 'production') {
                  navigate('/reports/production-chart');
                } else if (report.type === 'facility') {
                  navigate('/reports/facility-report');
                } else {
                  console.log('Navigate to:', report.type);
                }
              }}>
                <ListItemText primary={report.name} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Paper>
    </div>
  );
};

export default Reports;